import styled from "styled-components";

// Presentation follows the caller's existing semantic mapping; raw status codes stay unchanged.
const semanticColors = new Map([
    ["text-blue-500", ["#67bfe9", "rgba(55,159,219,0.13)", "rgba(103,191,233,0.30)"]],
    ["text-orange-500", ["#e9b768", "rgba(219,152,52,0.13)", "rgba(233,183,104,0.30)"]],
    ["text-green-500", ["#69c99f", "rgba(65,190,129,0.13)", "rgba(105,201,159,0.30)"]],
    ["text-red-500", ["#ee8189", "rgba(223,82,96,0.13)", "rgba(238,129,137,0.30)"]]
]);
const neutralColors = ["#d1d1d1", "rgba(255,255,255,0.06)", "rgba(255,255,255,0.20)"];
const displayLabels = new Map([["PendingStart", "Pending start"], ["UpdateFailed", "Update failed"]]);

const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 22px;
    padding: 2px 10px;
    border: 1px solid ${({ $colors }) => $colors[2]};
    border-radius: 6px;
    color: ${({ $colors }) => $colors[0]};
    background: ${({ $colors }) => $colors[1]};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
    cursor: default;
`;

// Opt in through includeStatus.renderStatus: ({statusValue, colorClass}) =>
// <PremiumStatusChip statusValue={statusValue} colorClass={colorClass} />.
export default function PremiumStatusChip({ statusValue, colorClass, label, className }) {
    return <Chip className={className} $colors={semanticColors.get(colorClass) || neutralColors}
        title={statusValue}>{label ?? displayLabels.get(statusValue) ?? statusValue ?? "Unknown"}</Chip>;
}
